<script setup lang="ts">
// Floating "back to top" button; appears after one viewport of scroll.
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { ArrowUp } from 'lucide-vue-next';

const { t } = useI18n();
const visible = ref(false);

function onScroll() {
  visible.value = window.scrollY > window.innerHeight;
}
function toTop() {
  window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
}
onMounted(() => window.addEventListener('scroll', onScroll, { passive: true }));
onBeforeUnmount(() => window.removeEventListener('scroll', onScroll));
</script>

<template>
  <Transition
    enter-active-class="transition-[opacity,transform] duration-200 motion-reduce:transition-none"
    leave-active-class="transition-[opacity,transform] duration-150 motion-reduce:transition-none"
    enter-from-class="translate-y-2 opacity-0"
    leave-to-class="translate-y-2 opacity-0"
  >
    <button
      v-if="visible"
      type="button"
      :aria-label="t('common.backToTop')"
      class="fixed bottom-[max(1.5rem,env(safe-area-inset-bottom))] left-6 z-40 grid size-11 place-items-center rounded-lg border border-border bg-surface/90 text-text-dim shadow-lift backdrop-blur transition-colors hover:border-text-mute hover:text-text sm:left-auto sm:right-6 sm:bottom-24"
      @click="toTop"
    >
      <ArrowUp class="size-5" :stroke-width="2" />
    </button>
  </Transition>
</template>
